module.exports = __webpack_public_path__ + "img/nullMind.b40a6c65.svg";